export class HybseConfig {
  // apiURL:string = 'https://api.hybse.dev/';
  // apiURL:string = 'http://127.0.0.1:8000/';
  // apiURL:string = 'https://apollo.hybsedev.ddns.net/';
  // apiURL: string = 'https://apollo.business-software.in/api/';
  //  apiURL: string = 'https://apollo.hybse.com/api/';
  // apiURL: string = 'https://hybse-auth.business-software.in/api/';

  // new_design url for BEX prod:
  // apiURL: string = `https://v3.bex.global/api/`;
  // authURL: string = `https://auth.bex.global/api/`;
  // dev API
  apiURL:string = 'https://hbv3.business-software.in/api/';
  authURL: string = 'https://hbauth.business-software.in/api/';

  // EXCHANGE WALLET
  // dev
  exchangeWallet: string = 'TCQ7BNM7NH47ZA2QLLH4DXGO7DGL5NNCCNN4SYRH';
  // production
  // exchangeWallet: string = 'NCWAFECBGKC6U272BGNAYLL322WWGKLWVHLEIGOC';
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/config/hybse.config.ts